import {Controller} from "@hotwired/stimulus"
import {Toast} from "@coreui/coreui"

export class ToastController extends Controller {
	connect() {
		this.toast = new Toast(this.element)
		this.toast.show()
	}

	disconnect() {
		this.element.remove()
	}
}